import classNames from 'classnames';
import { InputSwitch, InputSwitchProps } from 'primereact/inputswitch';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const StyledOverlayText = styled.div<{ isOn: boolean }>`
  text-transform: uppercase;
  font-size: var(--xsmall-font-size);
  font-weight: 500;
  color: var(--white-main);
  position: absolute;
  right: ${({ isOn }) => (isOn ? '32px' : '16px')};
  top: 1.5px;
  pointer-events: none;
`;

type AppSwitchPropsType = { withText?: boolean } & InputSwitchProps;

export const AppSwitch: React.FC<AppSwitchPropsType> = ({
  className,
  checked,
  withText = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const [isOn, setIsOn] = useState(checked);

  const styles = classNames(
    {
      ['switch-with-text']: withText,
    },
    className,
  );

  useEffect(() => {
    setIsOn(checked);
  }, [checked]);

  return (
    <div style={{ position: 'relative' }} className="switch-container">
      <InputSwitch checked={checked} className={styles} {...rest} />
      {withText && (
        <StyledOverlayText isOn={isOn} id="on-off-text" className="on-off-text">
          {isOn ? t('generic.toggle.on') : t('generic.toggle.off')}
        </StyledOverlayText>
      )}
    </div>
  );
};
